import { colors } from '../../../../utils/constants'

export const detailTaskStyles = {
	details: {
		width: 'initial !important'
	},
	enRetardIcon: {
		width: 24,
		height: 24,
		color: colors.error
	},
	iconTachePlanifier: {
		color: colors.tacheAPlanifier,
		width: 24,
		height: 24
	},
	iconTacheRealiser: {
		color: colors.tacheARealiser,
		width: 24,
		height: 24
	},
	iconTacheEnCoursOuTerminee: {
		color: colors.tacheEnCoursOuTerminee,
		width: 24,
		height: 24
	},
	textPlanifier: {
		backgroundColor: colors.tacheAPlanifier,
		color: 'white',
		fontSize: 14,
		width: 88,
		height: 28,
		textAlign: 'center' as 'center'
	},
	textRealiser: {
		backgroundColor: colors.tacheARealiser,
		color: 'white',
		fontSize: 14,
		width: 88,
		height: 28,
		textAlign: 'center' as 'center'
	},
	textEnCoursOuTerminee: {
		backgroundColor: colors.tacheEnCoursOuTerminee,
		color: 'white',
		fontSize: 14,
		width: 88,
		height: 28,
		textAlign: 'center' as 'center'
	},
	infoTache: {
		verticalAlign: 'sub'
	},
	description: {
		textAlign: 'justify' as 'justify'
	},
	instructions: {
		marginTop: 20,
		marginBottom: 10,
		textAlign: 'center' as 'center'
	},
	icon: {
		width: 24,
		height: 24
	},
	ajoutSuivi: {
		marginTop: 30,
		textAlign: 'center' as 'center'
	},
	detailsTache: {
		marginTop: 15
	},
	padText: {
		paddingLeft: 22
	},

	// Style info réalisation
	textSolutionOldPlanned: {
		color: colors.primary
	},
	textSolutionPlanned: {
		color: colors.primaryResultat
	}
}